// extracted by mini-css-extract-plugin
module.exports = {"tip":"Tip_tip__3pWNT","tipToTop":"Tip_tipToTop__12Nni"};